/* eslint-disable */
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import moment from 'moment';
import SelectPicker from 'rsuite/SelectPicker';
import styles from './BillsPage.module.scss';
// import ListTable from '../../../../Components/ListTable/ListTable';
import { BackdropLoader } from '../../Components/Loaders';
import ImageModal from '../../Components/Modals/ImageModal/ImageModal';
// import { ListModal } from '../../../Components/Modals';
import { formActions, modalActions } from '../../Actions';
import { notificationServices } from '../../Services';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import { POItemsModal } from '../../Components/Modals/POItemsModal';
import { PaymentModal } from '../../Components/Modals/PaymentModal';
// import { useAuth } from '../../Components/Auth/Login/auth';
import { urls } from '../../Constants';
import { TransactionsModal } from '../../Components/Modals/TransactionsModal';
import { addCommas, filtersInfoChip, getFileName, useQuery } from '../../Helpers';
import { AlertModal } from '../../Components/Modals';
import { FileUploaderModal } from '../../Components/Modals/FileUploaderModal';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import { BulkPaymentModal } from '../../Components/Modals/BulkPaymentModal';
import BillsListing from '../../Components/BillsListing/BillsListing';
import { BillPaymentModal } from '../../Components/Modals/BillPaymentModal';
import billPaymentsServices from '../../Services/billPayments.services';
import drawerActions from '@/Actions/drawer.actions';
import { Filter, RefreshCcw } from 'lucide-react';
import { Button, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import GlobalSearch from '@/Components/globalSearch/search';

const statusList = [
	{
		id: 'PENDING',
		title: 'PENDING',
	},
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
	{
		id: 'REJECTED',
		title: 'REJECTED',
	},
	{
		id: 'PAID',
		title: 'PAID',
	},
	{
		id: 'UNPAID',
		title: 'UNPAID',
	},
	{
		id: 'PARTIALLY_PAID',
		title: 'PARTIALLY PAID',
	},
	// Set by the finance system on the payment API: BOOKED -> PAYMENT INITIATED -> PAID,
	// or PAYMENT REJECTED when the bank payment fails.
	{
		id: 'BOOKED',
		title: 'BOOKED',
	},
	{
		id: 'PAYMENT_INITIATED',
		title: 'PAYMENT INITIATED',
	},
	{
		id: 'PAYMENT_REJECTED',
		title: 'PAYMENT REJECTED',
	},
	{
		id: 'APPROVAL_PENDING_FINANCE',
		title: 'APPROVAL PENDING FINANCE',
	},
	{
		id: 'APPROVAL_PENDING_MANAGER',
		title: 'APPROVAL PENDING MANAGER',
	},
];

const timeTypeArr = [
	{
		label: 'Created At',
		value: 'createdAt',
	},
	{
		label: 'Bill Date',
		value: 'transactionDate',
	},
	{
		label: 'Due Date',
		value: 'dueDate',
	},
];

function BillsPage({
	userPermissions,
	createPath,
	togglePOItemsModal,
	togglePaymentModal,
	// toggleTransactionsModal,
	toggleAlert,
	toggleFileUploaderModal,
	vendors,
	fetchVendors,
	toggleBulkPaymentModal,
	navState,
	toggleFiltersDrawer,
}) {
	const params = useQuery();
	let poId = params.get('poId') ? Number(params.get('poId')) : undefined;
	let billId = params.get('billId')
		? Number(params.get('billId'))
		: undefined;
	let grnId = params.get('grnId') ? Number(params.get('grnId')) : undefined;
	let clientPOId = params.get('clientPoId');
	const history = useHistory();
	// const { userConfig } = useAuth();
	const [isloading, setIsloading] = useState(false);
	const [billsList, setBillsList] = useState([]);
	const [update, setUpdate] = useState(-1);
	const [externalFilters, setExternalFilters] = useState([]);
	const [selectedBills, setSelectedBills] = useState([]);
	const [filters, setFilters] = useState({});
	const [parentType, setParentType] = useState('ALL');
	const [search, setSearch] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	// Payment info recorded against the listed bills, keyed by bill row id. Fetched in one
	// call for the whole page rather than per row, and merged into the listing columns.
	const [billPaymentsMap, setBillPaymentsMap] = useState({});
	const [billPaymentModal, setBillPaymentModal] = useState({
		show: false,
		bill: null,
		mode: 'view',
	});
	// const navRequisites = navState?.[urls.PURCHASE_ORDERS]?.requisites ?? [];
	// const navSelectedStore = navRequisites?.find((ele) => {
	// return ele?.type === 'store';
	// });
	const BILLS = useMemo(() => {
		return billsList?.filter((ele) => {
			if (!billId) return true;
			return ele?.id === billId;
		});
	}, [billsList]);

	const fetchBillPayments = async (billRowIds) => {
		if (!billRowIds?.length) {
			setBillPaymentsMap({});
			return;
		}
		try {
			const response = await billPaymentsServices.fetchBillPayments({
				data: {
					billIds: billRowIds,
				},
			});
			if (response?.statusCode === 200) {
				setBillPaymentsMap(response?.data?.billWisePayments ?? {});
			}
		} catch (error) {
			// A payments lookup failure must not blank the bills list, so it is logged and
			// the payment columns simply stay empty.
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	useEffect(() => {
		fetchBillPayments(
			BILLS?.map((ele) => {
				return ele?.id;
			})
		);
	}, [BILLS]);

	const openBillPaymentModal = (item, mode = 'view') => {
		setBillPaymentModal({
			show: true,
			bill: item,
			mode,
		});
	};

	const openRecordPaymentModal = (item) => {
		openBillPaymentModal(item, 'record');
	};

	const closeBillPaymentModal = () => {
		setBillPaymentModal({
			show: false,
			bill: null,
			mode: 'view',
		});
	};

	// A saved payment changes the bill's paid amount and status, so the list is refetched
	// rather than patched locally.
	const handleBillPaymentSaved = () => {
		setUpdate((prev) => {
			return prev + 1;
		});
	};

	useEffect(() => {
		if (poId) {
			handleFetchData();
			const poFilterExternal = {
				id: poId,
				type: 'orderId',
				title: `Order Id: ${clientPOId}`,
				removable: true,
				handleRemove: () => {
					params.delete('poId');
					params.delete('clientPoId');
					if (billId) {
						params.delete('billId');
						billId = null;
					}
					poId = null;
					clientPOId = null;
					setExternalFilters((prev) => {
						return prev?.filter((ele) => {
							return (
								ele?.type !== 'orderId' &&
								ele?.type !== 'billId'
							);
						});
					});
					history.replace({
						search: params.toString(),
					});
					setUpdate((prev) => {
						return prev + 1;
					});
				},
			};
			setExternalFilters((prev) => {
				const exists = prev?.find((ele) => {
					return ele?.type === 'orderId';
				});
				if (exists) {
					if (exists?.id !== poId) {
						return prev?.map((ele) => {
							if (ele?.type === 'orderId') {
								return poFilterExternal;
							}
							return ele;
						});
					}
					return prev;
				}
				return [...prev, poFilterExternal];
			});
		}
	}, [poId, billId]);

	useEffect(() => {
		if (grnId) {
			handleFetchData();
			const grnFilterExternal = {
				id: grnId,
				type: 'grnId',
				title: `GRN Id: ${grnId}`,
				removable: true,
				handleRemove: () => {
					params.delete('grnId');
					grnId = null;
					history.replace({
						search: params.toString(),
					});
					setUpdate((prev) => {
						return prev + 1;
					});
					setExternalFilters((prev) => {
						return prev?.filter((ele) => {
							return ele?.type !== 'grnId';
						});
					});
				},
			};
			setExternalFilters((prev) => {
				const exists = prev?.find((ele) => {
					return ele?.type === 'grnId';
				});
				if (exists) {
					if (exists?.id !== poId) {
						return prev?.map((ele) => {
							if (ele?.type === 'grnId') {
								return grnFilterExternal;
							}
							return ele;
						});
					}
					return prev;
				}
				return [...prev, grnFilterExternal];
			});
		}
	}, [grnId]);

	useEffect(() => {
		if (poId && billId) {
			const billFilterExternal = {
				id: billId,
				type: 'billId',
				title: `Bill Id: ${billId}`,
				removable: true,
				handleRemove: () => {
					params.delete('billId');
					billId = null;
					history.replace({
						search: params.toString(),
					});
					setExternalFilters((prev) => {
						return prev?.filter((ele) => {
							return ele?.type !== 'billId';
						});
					});
				},
			};
			setExternalFilters((prev) => {
				const exists = prev?.find((ele) => {
					return ele?.type === 'billId';
				});
				if (exists) {
					if (exists?.id !== poId) {
						return prev?.map((ele) => {
							if (ele?.type === 'billId') {
								return billFilterExternal;
							}
							return ele;
						});
					}
					return prev;
				}
				return [...prev, billFilterExternal];
			});
		}
	}, [grnId]);

	useEffect(() => {
		fetchVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const handleFetchData = async (isRefresh = false) => {
		setIsRefresh(isRefresh);
		setIsloading(true);
		setFilters({});
		const filters = {
			// fromStoreId: requestOptions?.store,
			orderId: poId,
			parentId: grnId,
		};
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							filters,
							type: 'BILL',
							transactionItems: true,
							parent: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				// setSelectedStore(store);
				setBillsList(responseData?.data);
				setSelectedBills([]);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const handleListFetch = async (requestOptions, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setIsloading(true);
		setFilters({
			...requestOptions,
		});
		const filters = {
			// fromStoreId: requestOptions?.store,
			vendors: requestOptions?.vendors?.id,
			storeId: requestOptions?.store?.id === -999 ? null : requestOptions?.store?.id,
			orderId: poId,
			parentId: grnId,
			status: requestOptions?.status,
			subTypes: requestOptions?.type === 'ALL' || requestOptions?.type === null ? ['GRN', 'ADVANCE', 'CAPEX'] : [requestOptions?.type],
		};
		if (requestOptions?.dateRange?.active) {
			filters.dateRangeFilter = {
				timeType: requestOptions?.timeType?.value,
				from: moment(requestOptions?.dateRange?.from).format(
					'YYYY-MM-DD'
				),
				to: moment(requestOptions?.dateRange?.to).format('YYYY-MM-DD'),
			};
		}
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							filters,
							type: 'BILL',
							transactionItems: true,
							parent: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				// setSelectedStore(store);
				setBillsList(responseData?.data);
				setSelectedBills([]);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const idSearch = async () => {
		setIsloading(true);
		const searchFilterPayload = {
			// fromStoreId: requestOptions?.store,
			...(search?.value === 'grnId' && {
				parentId: search?.searchValue ? Number(search?.searchValue) : "",
			}),
			...(search?.value === 'orderId' && {
				orderId: search?.searchValue ? search?.searchValue : "",
			}),
			...(search?.value === 'billId' && {
				clientTransactionId: search?.searchValue ? search?.searchValue : "",
			}),
		};
		try {
			const responseData =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							search: searchFilterPayload,
							type: 'BILL',
							transactionItems: true,
							parent: true,
						},
					},
				});
			if (responseData?.statusCode === 200) {
				// setSelectedStore(store);
				setBillsList(responseData?.data);
				setSelectedBills([]);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	}

	const handleApproveBill = async (item) => {
		setIsloading(true);
		let status = '';
		if (item?.transactionStatus === 'APPROVAL_PENDING_MANAGER') {
			status = 'APPROVAL_PENDING_FINANCE';
		}
		if (item?.transactionStatus === 'APPROVAL_PENDING_FINANCE') {
			status = 'UNPAID';
		}
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: item?.id,
					},
					data: {
						status,
						type: 'BILL',
						nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.BILLS}?poId=${item?.orderId}&clientPOId=${item?.clientOrderId}&billId=${item?.id}`,
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				togglePOItemsModal(false, {});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};
	const handleRejectBill = async (item, rejectionReason) => {
		setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: item?.id,
					},
					data: {
						rejectionReason,
						rejected: true,
						type: 'BILL',
						nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.BILLS}?poId=${item?.orderId}&clientPOId=${item?.clientOrderId}&billId=${item?.id}`,
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				togglePOItemsModal(false, {});
				toggleAlert(false, {});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const handleCancelBill = async (item) => {
		setIsloading(true);
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: item?.id,
					},
					data: {
						status: 'CANCELLED',
						type: 'BILL',
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	const handleAddClick = () => {
		history.push(createPath);
	};

	const handleMakePayment = async (data) => {
		try {
			const response =
				await inventoryAnalyticsServices.createTransactionRecord({
					data: {
						...data,
						type: 'PAYMENTS',
					},
				});
			if (response?.statusCode === 200) {
				// setStoreCreditsList(response?.data);
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const moreOptionsList = {
		// 'Create Credits': (po, cb) => {
		// const url = `${urls.EXTENSION}${urls.CREDITS}/add?billId=${po?.id}`;
		// history.push(url);
		// cb();
		// },
		'Upload Invoice': (po, cb) => {
			toggleFileUploaderModal(true, {
				heading: 'Upload Invoice',
				selectedFile: '',
				confirmText: 'Upload',
				id: po?.id,
			});
			cb();
		},
	};

	const handleInvoiceUpload = async (fileData, id) => {
		const billItem = billsList?.find((ele) => {
			return ele?.id === id;
		});
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: id,
					},
					data: {
						approved: false,
						status:
							billItem?.transactionStatus ===
								'APPROVAL_PENDING_MANAGER'
								? 'APPROVAL_PENDING_MANAGER'
								: 'APPROVAL_PENDING_FINANCE',
						type: 'BILL',
						uploadedDoc: fileData?.file,
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				togglePOItemsModal(false, {});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		} finally {
			setIsloading(false);
		}
		toggleFileUploaderModal(false, {});
		// eslint-disable-next-line no-console
	};

	const pushPoInformation = (item, vendorDetails, isApproval = true) => {
		togglePOItemsModal(true, {
			heading: `Bills Items of #${item?.clientTransactionId ??
				item?.id
				}`,
			...item,
			packagingCharges:
				item?.extraData?.packagingCharges,
			deliveryCharges:
				item?.extraData?.deliveryCharges,
			packagingTaxPercentage:
				item?.extraData
					?.taxOnPackagingCharges,
			deliveryTaxPercentage:
				item?.extraData
					?.taxOnDeliveryCharges,
			isApprove: isApproval,
			advanceBill: !item?.parentRowId,
			warningText:
				!item?.uploadedDoc &&
					item?.parentRowId
					? 'GRN Bill needs to have an invoice uploaded'
					: false,
			approvalText: item?.uploadedDoc
				? 'I have checked and verify that the Vendor Invoice and Bill Items are correct.'
				: 'I have checked that the Bill is correct.',
			showTotal: item?.parentRowId,
			showPdf: true,
			showPoDetails: true,
			poClosingData: item?.extraData?.poClosingData,
			width: '90%',
			poId: item?.orderId,
			height: '90%',
			transactionData: {
				'Bill ID':
					item?.clientTransactionId,
				'PO ID': item?.clientOrderId,
				Vendor: item?.vendorName,
				'Deliver To Store': item?.storeName,
				'Vendor GSTIN':
					vendorDetails?.gstin ?? '',
				'Deliver To Store GSTIN':
					item?.storeGstin,
				'Vendor Address': `${vendorDetails?.shippingAddressCity ??
					''
					} ${vendorDetails?.shippingAddressState ??
					''
					}, ${vendorDetails?.shippingAddressPinCode ??
					''
					}`,
				...((item?.parentTransactionRecord?.clientTransactionId || item?.parentRowId) && {
					'GRN ID': item?.parentTransactionRecord?.clientTransactionId || item?.parentRowId,
				}),
				'Client Bill ID':
					item?.clientTransactionId,
				'GRN Date': moment(
					item?.parentTransactionRecord
						?.transactionDate
				).format('YYYY-MM-DD'),
				'Bill Date': moment(
					item?.transactionDate
				).format('YYYY-MM-DD'),
				'Bill Status':
					item?.transactionStatus,
				'Bill Amount':
					'\u20B9' +
					item?.finalTransactionAmount,
				'Payment Term':
					item?.extraData?.paymentTerm,
				'Order Amount':
					'\u20B9' + item?.orderAmount,
				empty: '',
				'Vendor Invoice Amount': addCommas(item?.invoiceAmount, 'IN', true),
				'Vendor Invoice Number': item?.invoiceRef,
				'Vendor Invoice Date': item?.invoiceDate,
				Notes: item?.description,
			},
			excludedColumns: [
				'Packaged',
				'Dispatched',
				'Returned Quantity',
				// 'Received',
				'Fulfilled',
				'From Process',
				'PO Id',
				'Returned',
				'Quantity',
				'Used For',
				'Last Purchase Rate 1',
				'Last Purchase Rate 2',
				'Last Purchase Rate 3',
				'Recommended Quantity',
				'Standard PO Qty'
			],
			hideItems: !item?.parentRowId,
			isAdvanceBill: !item?.parentRowId,
			// delta: item?.extraData?.poClosingData?.creditValue,
		});
	};

	const viewMoreOptionsList = {
		// 'View Payments': (item, cb) => {
		// 	window.open(`${urls.EXTENSION}${urls.PAYMENT_MADE}?billId=${item?.id}&clientTransactionId=${item?.clientTransactionId}`);
		// 	// toggleTransactionsModal(true, {
		// 	// listData: item?.childTransactionRecord?.filter((ele) => {
		// 	// return ele?.rowType !== 'CREDIT';
		// 	// }),
		// 	// transactionType: 'PAYMENTS',
		// 	// type: 'paymentMade',
		// 	// heading: `Payment Made For Bill #${item?.clientTransactionId}`,
		// 	// });
		// 	cb();
		// },
		'View Payment Info': (item, cb) => {
			openBillPaymentModal(item, 'view');
			cb();
		},
		'View Invoice': (item, cb) => {
			if (!item?.uploadedDoc) {
				notificationServices?.generateNotification({
					type: 'error',
					message: 'No invoice uploaded',
				});
			} else {
				window.open(item?.uploadedDoc, '_blank');
			}
			cb();
		},
		'View Items': (item, cb) => {
			const vendorDetails = vendors?.find((ele) => {
				return ele?.id === item?.vendorId;
			});
			const isAdvanceBill = !item?.parentRowId;
			if (isAdvanceBill) {
				notificationServices?.generateNotification({
					type: 'error',
					message: 'Advance bill have no item',
				});
				return;
			}
			pushPoInformation(item, vendorDetails, false);
			cb();
		},
		'View Credit Note/Debit Note Documnet': (item, cb) => {
			const doc = BILLS?.find((ele) => ele?.id === item?.id)?.extraData?.poClosingData?.creditDoc;
			if (doc) {
				window.open(doc, '_blank');
			}
			cb();
		},
	};

	const handleBulkPayment = () => {
		notificationServices.generateNotification({
			type: 'warning',
			message: 'Only Un-Paid bills are selected',
		});
		const selectedBillsData = selectedBills
			?.map((ele) => {
				const billItem = BILLS?.find((bill) => {
					return bill?.id === ele;
				});
				return billItem;
			})
			?.filter((ele) => {
				return (
					['UNPAID', 'BOOKED', 'PAYMENT_INITIATED', 'PAYMENT_REJECTED'].includes(ele?.transactionStatus) &&
					!!ele?.parentRowId
				);
			});
		const vendorWiseBills = {};
		selectedBillsData?.forEach((ele) => {
			const vendorExists = vendorWiseBills?.[ele?.vendorId];
			if (vendorExists) {
				vendorWiseBills[ele?.vendorId]?.bills?.push(ele);
			} else if (ele?.vendorId !== null) {
				vendorWiseBills[ele?.vendorId] = {
					vendorId: ele?.vendorId,
					vendorName: ele?.vendorName,
					bills: [ele],
				};
			}
		});
		toggleBulkPaymentModal(true, {
			vendorWiseBills: Object.values(vendorWiseBills),
		});
	};

	const handleParentType = (value) => {
		setParentType(value);
	};

	const filtersInfo = {
		header: {
			store: false,
			statusAndTypes: false,
			date: false,
		},
		filteredStore: {
			text: 'Billed Store',
			show: true,
		},
		vendor: {
			text: 'Billed by Vendor',
			show: true,
		},
		status: {
			text: 'Bill Status',
			show: true,
		},
		type: {
			text: 'Bill Type',
			show: true,
			list: [
				{
					type: 'ALL',
					label: 'All',
				},
				{
					type: 'GRN',
					label: 'GRN',
				},
				{
					type: 'ADVANCE',
					label: 'Advance',
				},
				{
					type: 'CAPEX',
					label: 'Capex',
				},
			]
		},
		dateRange: {
			show: true,
			text: 'Bill Date',
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
	};

	const exportInfo = {
		showExportBtn: true,
	};

	const handleExportData = () => {
		const COLMAP = {
			id: 'id',
			'Bill Type': 'id',
			Vendor: 'vendorName',
			Store: 'fromStoreName',
			'Billing Store': 'storeName',
			'Order id': 'clientOrderId',
			'GRN Id': 'parentRowId',
			'Created By': 'initiatedByUserDisplayName',
			'Created At': 'createdAt',
			'Client Bill. id': 'clientTransactionId',
			'Due Date': 'dueDate',
			'Bill date': 'transactionDate',
			'Bill Amount': 'finalTransactionAmount',
			'Order Amount': 'orderAmount',
			'Credit/Debit Value': 'extraData',
			'Credit Doc': 'extraData',
			'Rejection Reason': 'description',
			'Paid Amount': 'currentAmount',
			'Payment Mode': 'id',
			'Reference No': 'id',
			'Payment Date': 'id',
			'Payment Notes': 'id',
			'L1 Action By': 'l1ActionByUserDisplayName',
			'L2 Action By': 'l2ActionByUserDisplayName',

			Status: 'id',
		};
		const headers = Object.keys(COLMAP);

		// Prepare rows from data using COLMAP
		const rows = BILLS?.map(bill => {
			return headers.map(header => {
				if (header === 'Bill Type') {
					const type = bill?.subType;
					return type || '-';
				}
				if (header === 'Rejection Reason') {
					if (bill?.transactionStatus === 'REJECTED') {
						const rejectionReason = `(Reason: ${bill?.description})`;
						return rejectionReason || '-';
					}
					return '-';
				}
				if (header === 'Status') {
					const status = bill?.transactionStatus;
					return status || '-';
				}
				if (header === 'GRN Id') {
					const grnId = bill?.parentTransactionRecord?.clientTransactionId || bill?.parentRowId;
					return grnId || '-';
				}
				if (header === 'Credit Doc') {
					const creditDoc = bill[COLMAP[header]]?.poClosingData?.creditDoc;
					return creditDoc || '-';
				}
				if (
					['Payment Mode', 'Reference No', 'Payment Date', 'Payment Notes'].includes(
						header
					)
				) {
					const latest = billPaymentsMap?.[bill?.id]?.latestPayment;
					if (!latest) {
						return '-';
					}
					if (header === 'Payment Mode') {
						return latest?.paymentMode || '-';
					}
					if (header === 'Reference No') {
						return latest?.referenceNumber || '-';
					}
					if (header === 'Payment Date') {
						return latest?.paymentDate
							? moment(latest.paymentDate).format('DD-MM-YYYY')
							: '-';
					}
					// Commas inside a note would split the CSV row, so strip them.
					return (latest?.notes || '-')?.replace(/,/g, ' ');
				}
				if (header === 'Credit/Debit Value') {
					const creditValue = bill[COLMAP[header]]?.poClosingData?.creditValue;
					return creditValue || '-';
				}
				const value = bill[COLMAP[header]];

				return value || '-';
			});
		});
		const csvData = [headers, ...rows];

		// Generate filename with timestamp
		const filename = getFileName(filters);

		// Download CSV
		const csvContent = csvData.map(row => row.join(',')).join('\n');
		const csvFile = new Blob([csvContent], { type: 'text/csv' });

		// Create download link
		const downloadLink = document.createElement('a');
		downloadLink.download = filename;
		downloadLink.href = window.URL.createObjectURL(csvFile);
		downloadLink.style.display = 'none';

		// Add to DOM, trigger click, then clean up
		document.body.appendChild(downloadLink);
		downloadLink.click();
		window.URL.revokeObjectURL(downloadLink.href);
		document.body.removeChild(downloadLink);
	};


	const dropDownItems = [
		{
			label: 'Bill ID',
			value: 'billId',
			placeholder: 'Search by Bill ID',
			getData: true,
		},
		{
			label: 'GRN ID',
			value: 'grnId',
			placeholder: 'Search by GRN ID',
			getData: true,
		},
		{
			label: 'Order ID',
			value: 'orderId',
			placeholder: 'Search by Order ID',
			getData: true,
		},
	];

	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			handleListFetch(filters);
		}
	}, [search?.searchValue]);

	const handleCall = (e) => {
		if (e.key === 'Enter') {
			idSearch();
		}
	};

	return (
		<div className={styles.root}>
			{/* <ListModal handleConfirm={iAmClicked} singleSelectable /> */}
			<BackdropLoader showProgress isLoading={isloading} />
			<ImageModal />
			<POItemsModal
				handleConfirm={handleApproveBill}
				handleReject={handleRejectBill}
			/>
			<AlertModal />
			<TransactionsModal />
			<BulkPaymentModal />
			<FileUploaderModal handleConfirm={handleInvoiceUpload} />
			<PaymentModal handleConfirm={handleMakePayment} />
			<BillPaymentModal
				show={billPaymentModal?.show}
				bill={billPaymentModal?.bill}
				mode={billPaymentModal?.mode}
				handleClose={closeBillPaymentModal}
				onPaymentSaved={handleBillPaymentSaved}
			/>
			<div className={styles.header}>
				<ImagesFinder
					onSubmit={poId || grnId ? handleFetchData : handleListFetch}
					update={update}
					statusList={statusList}
					timeTypeArray={timeTypeArr}
					externalFilters={externalFilters}
					filtersInfo={filtersInfo}
					exportInfo={exportInfo}
				/>
				<div className='flex flex-col gap-2 w-full'>
					<div className='flex justify-between m-4 w-full items-center'>
						<span className='font-bold text-[16px]'>Bills List</span>
					</div>
					<div className='flex gap-4 w-full justify-start items-center py-1'>
						<div className='w-[82%]'>
							<GlobalSearch
								dropDownOptions={dropDownItems}
								setSelectedValue={setSearch}
								handleValue={handleCall}
								isRefresh={isRefresh}
							/>
						</div>
						<Tooltip title='Refresh Bills'>
							<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
								handleListFetch(filters, true);
							}} />
						</Tooltip>
						<Button
							onClick={() => {
								toggleFiltersDrawer(true, {
									exportFrontend: true,
									handleExportFrontend: handleExportData,
								});
							}}
							className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
						>
							<span className='text-nowrap'>Filter and Export</span>
							<Filter className='size-4' />
						</Button>
					</div>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles['list-container']}>
				<BillsListing
					BILLS={BILLS}
					vendors={vendors}
					userPermissions={userPermissions}
					togglePaymentModal={togglePaymentModal}
					toggleFileUploaderModal={toggleFileUploaderModal}
					togglePOItemsModal={togglePOItemsModal}
					toggleAlert={toggleAlert}
					handleCancelBill={handleCancelBill}
					selectedBills={selectedBills}
					pushPoInformation={pushPoInformation}
					setSelectedBills={setSelectedBills}
					moreOptionsList={moreOptionsList}
					viewMoreOptionsList={viewMoreOptionsList}
					handleBulkPayment={handleBulkPayment}
					navState={navState}
					billPaymentsMap={billPaymentsMap}
				openRecordPaymentModal={openRecordPaymentModal}
					hideExport={true}
				/>
			</div>
		</div>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions, navState } = state.navigation;
	const { LIST: vendors } = state.form.ALL_VENDORS.data;

	return {
		userPermissions,
		navState,
		vendors,
	};
};

const mapDispatchToProps = {
	toggleModal: modalActions.toggleListModal,
	togglePOItemsModal: modalActions.togglePOItemsModal,
	togglePaymentModal: modalActions.togglePaymentModal,
	toggleTransactionsModal: modalActions.toggleTransactionsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleBulkPaymentModal: modalActions.toggleBulkPaymentModal,
	fetchVendors: formActions.gateway,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillsPage);
